// extracted by mini-css-extract-plugin
export const footerContainer = "footer-module--footerContainer--38kEX";
export const socialsContainer = "footer-module--socialsContainer--1kn5U";
export const socialsIcon = "footer-module--socialsIcon--1wgCA";
export const copyright = "footer-module--copyright--1R0IZ";